const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

async function processStatus(response: Response) {
    if (response.ok) {
        const res = await response.json();
        return {
            ...res,
            status: response.status,
        };
    }
    if (response.status === 401) {
        window.localStorage.removeItem('userToken');
        window.location.href = '/login';
    }
    return {
        success: false,
        status: response.status,
    };
}

/* Easy fetch is xhr for GET, DELETE..., request without body */
export const easyFetch = async<T> (
    url: string,
    method: string,
    query?: string,
): Promise<T> => {
    const options = { method, credentials: 'same-origin' as RequestCredentials };
    const requestUri = query ? `${API_ENDPOINT}/${url}?${query}` : `${API_ENDPOINT}/${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (jsonRes.success) {
            return jsonRes.extras;
        }
        throw new Error('500');
    } catch (error) {
        throw new Error('400');
    }
};

export const authEasyFetch = async<T> (
    url: string,
    method: string,
    query?: string,
): Promise<T> => {
    const { admintoken } = window.localStorage;
    const options = {
        method,
        credentials: 'same-origin' as RequestCredentials,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${admintoken}`,
        },
    };
    const requestUri = query ? `${API_ENDPOINT}${url}?${query}` : `${API_ENDPOINT}${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (jsonRes.success) {
            return jsonRes.extras;
        }
        throw new Error('500');
    } catch (error) {
        throw new Error('400');
    }
};

/* Body fetch is xhr for POST, PUT..., request with body */
export const bodyFetch = async<TB, TR> (
    url: string,
    method: string,
    postData: TB,
    query?: string
): Promise<TR> => {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin' as RequestCredentials,
        method,
        body: JSON.stringify(postData),
    };
    const requestUri = query ? `${API_ENDPOINT}${url}?${query}` : `${API_ENDPOINT}${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (jsonRes.success) {
            return jsonRes.extras;
        }
        return jsonRes.error;
    } catch (error) {
        throw new Error('400');
    }
};

export const authBodyFetch = async<TB, TR> (
    url: string,
    method: string,
    postData: TB,
    query?: string
): Promise<TR> => {
    const { userToken } = window.localStorage;
    const options = {
        method,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userToken}`,
        },
        credentials: 'same-origin' as RequestCredentials,
        body: JSON.stringify(postData),
    };
    const requestUri = query ? `${API_ENDPOINT}${url}?${query}` : `${API_ENDPOINT}${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (jsonRes.success) {
            return jsonRes.extras;
        }
        throw new Error('500');
    } catch (error) {
        throw new Error('400');
    }
};

export const authUploadFetch = async<T> (
    url: string,
    formData: FormData,
    query?: string,
): Promise<T> => {
    const { userToken } = window.localStorage;
    const options = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${userToken}`,
        },
        body: formData,
    };
    const requestUri = query ? `${API_ENDPOINT}${url}?${query}` : `${API_ENDPOINT}${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (jsonRes.success) {
            return jsonRes.extras;
        }
        throw new Error('500');
    } catch (error) {
        throw new Error('400');
    }
};

// export const authDownload = async (url, method, postData, query) => {
//     const options = {
//         method,
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${auth.token()}`,
//         },
//         credentials: 'same-origin',
//         body: JSON.stringify(postData),
//     };
//     const requestUri = query ? `${API_ENDPOINT}${url}?${query}` : `${API_ENDPOINT}${url}`;

//     let filename = 'download';
//     return fetch(requestUri, options)
//         .then(res => {
//             const disposition = res.headers.get('content-disposition');
//             if (disposition && disposition.match(/attachment/)) {
//                 filename = disposition.replace(/attachment;.*filename=/, '').replace(/"/g, '');
//             }
//             return res.blob();
//         })
//         .then(blob => {
//             const objurl = window.URL.createObjectURL(blob);
//             const a = document.createElement('a');
//             a.href = objurl;
//             a.download = filename;
//             document.body.appendChild(a);
//             a.click();
//             a.remove();
//         });
// };

export const easyExternalFetch = async<T> (
    url: string,
    method: string,
    query?: string
): Promise<T> => {
    const options = { method, credentials: 'same-origin' as RequestCredentials };
    const requestUri = query ? `${url}?${query}` : `${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (res.status === 200) {
            return jsonRes;
        }
        throw new Error('500');
    } catch (error) {
        throw new Error('400');
    }
};

export const bodyExternalFetch = async<TB, TR> (
    url: string,
    method: string,
    postData: TB,
    query?: string
): Promise<TR> => {
    const options = {
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'same-origin' as RequestCredentials,
        method,
        body: JSON.stringify(postData),
    };
    const requestUri = query ? `${url}?${query}` : `${url}`;

    try {
        const res = await fetch(requestUri, options);
        const jsonRes = await processStatus(res);

        if (res.status === 200) {
            return jsonRes;
        }
        throw new Error('500');
    } catch (error) {
        throw new Error('400');
    }
};
